import * as React from 'react';

import * as styles from './preloader_wrapper.css';
import { Spinner } from '@cian/ui-kit';

interface IPreloaderWrapperProps {
  size?: number;
}

export const PreloaderWrapper = (props: IPreloaderWrapperProps) => (
  <div className={styles['overlay']}>
    <Spinner size={props.size} />
  </div>
);
